const FAKE_DOOR_FLAG_ID = 'fake-door';
const FAKE_DOOR_SESSION_KEY = 'olx_benefits';
const FAKE_DOOR_SESSION_COOKIE = 'onap';
const FAKE_DOOR_USER_ID_PARAM = 'iid';
const FAKE_DOOR_TRACKING_KEYS = {
  pageView: 'delivery_challenge_home_page_view',
  mailClick: 'delivery_challenge_pick_reward_click',
  delivery: 'delivery_challenge_free_ship_submit',
  money: 'delivery_challenge_free_lf_vas_submit',
  chat: 'delivery_challenge_prio_support_submit',
  discount: 'delivery_challenge_discounts_submit',
} as Record<string, string>;

export {
  FAKE_DOOR_FLAG_ID,
  FAKE_DOOR_SESSION_KEY,
  FAKE_DOOR_SESSION_COOKIE,
  FAKE_DOOR_USER_ID_PARAM,
  FAKE_DOOR_TRACKING_KEYS,
};
